module.exports = __webpack_public_path__ + "32ef95929960684880315d424c8044b3.pdf";